import { render } from "./footer.vue?vue&type=template&id=3aa4cd12&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=3aa4cd12&scoped=true&lang=css"

import exportComponent from "/builds/2022/tjusls-china/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa4cd12"]])

export default __exports__